<template>
  <v-container fluid pa-0>
    <sec-contact></sec-contact>
    <sec-diagonal v-model="this.$diagonal.bottom"></sec-diagonal>
    <sec-diagonal v-model="this.$diagonal.top"></sec-diagonal>
  </v-container>
</template>

<script>

import SecContact from '@/components/pages/public/SecContact';
import SecDiagonal from '@/components/pages/public/SecDiagonal';

export default {
  name: "PageDemo",
  components: {
    SecContact, SecDiagonal
  },
  data: () => ({
  }),
};
</script>

<style>
</style>
